export default "__VITE_ASSET__DCOgmjaX__"